import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const Product = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${tokens.radius.l};
  padding: ${tokens.spacer.x2};
  gap: ${tokens.spacer.x2};
`;
